import { GeoServer } from "safesystem_geoserver-api";

import type { Basemap } from "@/models/saferoads/interfaces";

import mapImgJpg from "@/assets/map.jpg";
import mapImgWebp from "@/assets/map.webp";
import satelliteImgJpg from "@/assets/satellite.jpg";
import satelliteImgWebp from "@/assets/satellite.webp";

// settings for all environments
export const copyrightStartYear = parseInt(import.meta.env.VITE_YEAR_COPYRIGHT_START as string);

// Abley Google Analytics / Development
export const gaTrackingId = import.meta.env.VITE_ID_TRACKING_GA as string;

export const targetSchemaVersion = import.meta.env.VITE_SCHEMA_VERSION as string;

const urlDefaultBasemap = import.meta.env.VITE_DEFAULT_BASEMAP as string;
const urlSatelliteBasemap = import.meta.env.VITE_SATELLITE_BASEMAP as string;
export const maptilerKey = import.meta.env.VITE_MAPTILER_KEY as string;

export const defaultBasemap: Basemap = {
	id: "map",
	label: "Map",
	altText: "Switch to default basemap",
	image: { jpg: mapImgJpg, webp: mapImgWebp },
	source: `${urlDefaultBasemap}?key=${maptilerKey}`,
};
export const satelliteBasemap: Basemap = {
	id: "satellite",
	label: "Satellite",
	altText: "Switch to satellite basemap",
	image: { jpg: satelliteImgJpg, webp: satelliteImgWebp },
	source: `${urlSatelliteBasemap}?key=${maptilerKey}`,
};
export const basemaps: Basemap[] = [defaultBasemap, satelliteBasemap];

export const apiHost = import.meta.env.VITE_API_HOST as string;
if (apiHost === undefined) {
	throw new Error("Environment variable VITE_API_HOST not specified.");
}
export const geoServer = new GeoServer(apiHost);

export const appVersion = import.meta.env.VITE_PACKAGE_VERSION as string;

export const gisServicesPath = import.meta.env.VITE_GIS_SERVICES_PATH as string;
export const safesystemAiPath = import.meta.env.VITE_SAFESYSTEMAI_PATH as string;
export const methodLink = import.meta.env.VITE_METHOD_LINK as string;
export const haloLink = import.meta.env.VITE_HALO_LINK as string;
export const contextLayerId = import.meta.env.VITE_CONTEXT_LAYER_ID as string;
